import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IVipIconProps extends ISvgIconProps {

}

export class VipIcon extends React.Component<IVipIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g transform="translate(3.6 5.773)">
                    <path d="M6.125 -6.142 3.872 0H2.376L0.123 -6.142H1.44l1.69 4.88 1.68 -4.88Zm1.971 0V0H6.864V-6.142ZM13.79 -4.24a1.913 1.913 0 0 1 -0.234 0.924 1.713 1.713 0 0 1 -0.73 0.695 2.657 2.657 0 0 1 -1.254 0.264H10.542V0h-1.232V-6.142h2.262a2.733 2.733 0 0 1 1.214 0.246 1.717 1.717 0 0 1 0.753 0.678A1.906 1.906 0 0 1 13.79 -4.24ZM11.52 -3.353a1.068 1.068 0 0 0 0.757 -0.234 0.859 0.859 0 0 0 0.246 -0.655q0 -0.898 -1.003 -0.898H10.542v1.786Z" transform="translate(1.44 9.8)" fill="currentColor"/>
                    <path d="M16.8 0.6H0V-0.6H16.8Z" transform="translate(0 0.6)" fill="currentColor"/>
                    <path d="M16.8 0.6H0V-0.6H16.8Z" transform="translate(0 12.6)" fill="currentColor"/>
                </g>
            </SvgIcon>
        );
    }
}
